import { Component } from '@angular/core';

@Component({
  selector: 'sg-general-error',
  templateUrl: './general-error.component.html',
  styleUrls: ['./general-error.component.scss'],
  standalone: false,
})
export class SgGeneralErrorComponent {
  constructor() {}
}
